import { render, staticRenderFns } from "./PreparingChat.vue?vue&type=template&id=6359744a"
import script from "./PreparingChat.vue?vue&type=script&lang=ts"
export * from "./PreparingChat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports